if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        // --- INTELLIGENTE SPERRE ---
        const checkbox = document.getElementById('product-agree');
        
        // Prüft, ob die Checkbox überhaupt existiert (nur bei den 3 Tags der Fall)
        if (checkbox) {
          if (!checkbox.checked) {
            alert('Bitte bestätigen Sie die Bedingungen (Häkchen setzen), um fortzufahren.');
            
            // Verhindert, dass der Button im Lade-Zustand stecken bleibt
            this.submitButton.classList.remove('loading');
            if (this.querySelector('.loading__spinner')) {
              this.querySelector('.loading__spinner').classList.add('hidden');
            }
            this.submitButton.removeAttribute('aria-disabled');
            return; // STOPPT HIER: Kein Warenkorb, kein Springen!
          }
        }
        // Wenn keine Checkbox da ist, geht das Skript hier einfach normal weiter

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        this.updatePurchaseSnapshot();
        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.GenkiAnalytics?.addToCart?.(
                response.product_id || formData.get('id'),
                response.product_title || response.title,
                response.variant_id || formData.get('id'),
                formData.get('quantity') || 1
              );
              window.location = window.routes.cart_url;
              return;
            }

            window.GenkiAnalytics?.addToCart?.(
              response.product_id || formData.get('id'),
              response.product_title || response.title,
              response.variant_id || formData.get('id'),
              formData.get('quantity') || 1
            );

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      updatePurchaseSnapshot(variant = null) {
        const selectedVariant = variant || this.selectedVariantSnapshot();
        const fallback = this.variantIdInput;
        const barcode = selectedVariant ? (selectedVariant.raw_barcode || selectedVariant.barcode) :
          (fallback?.value === fallback?.dataset.genkiDispatchVariantId ? fallback.dataset.genkiDispatchBarcode : '');
        const dispatch = window.GenkiDispatchPlan?.match(selectedVariant || barcode);
        this.setPurchaseProperty('_dispatch_resume', dispatch?.resume_date || '', 'data-genki-dispatch-resume');
        this.setPurchaseProperty('Versandhinweis', dispatch ? window.GenkiDispatchPlan.text(dispatch.resume_date) : '', 'data-genki-dispatch-notice');
        if (!selectedVariant) return;
        const snapshot = this.purchaseSnapshotForVariant(selectedVariant);
        this.setPurchaseProperty('_logic', snapshot.logic, 'data-genki-purchase-logic');
        this.setPurchaseProperty('_date', snapshot.date, 'data-genki-purchase-date');
        this.setPurchaseProperty('_logic_rule', 'genki_purchase_status_v1', 'data-genki-purchase-rule');
        this.setPurchaseProperty('_source', snapshot.source, 'data-genki-purchase-source');
        this.setPurchaseProperty('_location', snapshot.location, 'data-genki-purchase-location');
        this.setPurchaseProperty('Gekauft als', snapshot.publicLabel, 'data-genki-purchase-public-label');
      }

      selectedVariantSnapshot() {
        const holder = this.closest('product-info') || document;
        const currentVariantId = String(this.variantIdInput?.value || '');
        const selectedJson = holder.querySelector('variant-selects [data-selected-variant]')?.textContent;
        if (selectedJson) {
          try {
            const parsed = JSON.parse(selectedJson);
            if (!currentVariantId || String(parsed?.id || '') === currentVariantId) return parsed;
          } catch (error) {
            console.warn('Genkidama purchase snapshot konnte Varianten-Daten nicht lesen.', error);
          }
        }
        return null;
      }

      purchaseSnapshotForVariant(variant) {
        const barcode = String(variant?.raw_barcode || variant?.barcode || '').toLowerCase();
        const sku = String(variant?.raw_sku || variant?.sku || '').toLowerCase();
        const quantity = Number(variant?.inventory_quantity);
        const policy = String(variant?.inventory_policy || '').toLowerCase();
        let logic = 'stock';
        let source = '';
        let location = '';
        let publicLabel = '';

        if (policy === 'continue' && Number.isFinite(quantity) && quantity <= 0) {
          logic = 'preorder';
          source = 'heo';
          location = 'HEODEUTSCHLAND';
          publicLabel = 'Vorbestellung';
        } else if (barcode.includes('3month;;') || barcode.includes('45-90') || barcode.includes('45 bis 90') || barcode.includes('seeweg')) {
          logic = 'stock_3month';
          publicLabel = 'Seeweg (45-90 Tage)';
        } else if (barcode.includes('4-15;;') || barcode.includes('4 - 15;;')) {
          logic = 'stock_4-15';
          publicLabel = 'Fernlager (4-15 Tage)';
        } else if (barcode.includes('7-14;;')) {
          logic = 'stock_7-14';
        } else if (barcode.includes('1-3;;')) {
          logic = 'stock_1-3';
        } else if (barcode.includes('nachb;;') || barcode.includes('nach;;')) {
          logic = 'backorder';
          publicLabel = barcode.includes('2-7;;') ? 'Nachbestellung (2-7 Tage)' : 'Nachbestellung';
        }

        const inferredSource = this.purchaseSourceForVariantText(`${sku} ${barcode}`);
        if (inferredSource || source === 'heo') {
          source = inferredSource || source;
          location = this.purchaseLocationForSource(source);
        }

        return { logic, date: this.releaseDateFromBarcode(barcode), source, location, publicLabel };
      }

      purchaseSourceForVariantText(value) {
        const text = String(value || '').toLowerCase();
        if (text.includes('_heo') || /\bheo\b/.test(text) || text.includes('heodeutschland')) return 'heo';
        if (text.includes('hobbygenki') || text.includes('hobby genki') || text.includes('hghv') || text.includes('hg;;')) return 'hghv';
        if (text.includes('amiami') || text.includes('ami ami') || text.includes('aa;;')) return 'aa';
        if (text.includes('ninnin') || text.includes('nin-nin') || text.includes('nin nin') || text.includes('nn;;')) return 'nn';
        if (text.includes('hobbysearch') || text.includes('hobby search') || text.includes('hss')) return 'hss';
        if (text.includes('cubegolem') || text.includes('cube golem') || text.includes('cube-golem')) return 'cubegolem';
        return '';
      }

      purchaseLocationForSource(source) {
        return {
          heo: 'HEODEUTSCHLAND',
          hghv: 'Genkidama-HGHV',
          aa: 'AmiAmi',
          nn: 'Nin-Nin',
          hss: 'HobbySearch',
          cubegolem: 'CubeGolem',
        }[source] || '';
      }

      releaseDateFromBarcode(barcode) {
        const match = String(barcode || '').match(/(?:change|code);;\s*([^;\s]+)/i);
        return match ? match[1].trim().slice(0, 40) : '';
      }

      setPurchaseProperty(key, value, markerAttribute) {
        let input = this.form.querySelector(`[${markerAttribute}]`);
        if (!value && (key === '_source' || key === '_location' || key === 'Gekauft als' || key === '_dispatch_resume' || key === 'Versandhinweis')) {
          if (input) input.remove();
          return;
        }
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = `properties[${key}]`;
          input.setAttribute(markerAttribute, '');
          this.form.appendChild(input);
        }
        input.value = value || '';
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
